/**
 * metaTradify Logo — Stylized "M" formed by candlestick/chart lines
 */
export function MetaTradifyLogo({ size = 32, className = '' }) {
  return (
    <svg width={size} height={size} viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg" className={className}>
      <rect width="40" height="40" rx="8" fill="#10B981" />
      {/* Stylized M from chart lines */}
      <path d="M8 28L14 16L20 22L26 12L32 20" stroke="white" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round" />
      {/* Candlestick accents */}
      <line x1="14" y1="14" x2="14" y2="18" stroke="white" strokeWidth="2" strokeLinecap="round" opacity="0.7" />
      <line x1="26" y1="10" x2="26" y2="14" stroke="white" strokeWidth="2" strokeLinecap="round" opacity="0.7" />
      {/* Baseline */}
      <line x1="8" y1="32" x2="32" y2="32" stroke="white" strokeWidth="1.5" strokeLinecap="round" opacity="0.3" />
    </svg>
  );
}

export function MetaTradifyLogoSmall({ size = 24, className = '' }) {
  return (
    <svg width={size} height={size} viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg" className={className}>
      <rect width="40" height="40" rx="8" fill="#10B981" />
      <path d="M8 28L14 16L20 22L26 12L32 20" stroke="white" strokeWidth="3.5" strokeLinecap="round" strokeLinejoin="round" />
      <line x1="14" y1="14" x2="14" y2="18" stroke="white" strokeWidth="2" strokeLinecap="round" opacity="0.7" />
      <line x1="26" y1="10" x2="26" y2="14" stroke="white" strokeWidth="2" strokeLinecap="round" opacity="0.7" />
    </svg>
  );
}
